/*
 * localization-form.js
 * Vanilla JS controller for the Shopify Markets localization form rendered by
 * snippets/currency-selector.liquid. Sets the matching hidden input
 * (country_code / language_code) and submits the closest localization form.
 *
 * No global pollution. Resilient to missing elements.
 */
(function () {
  'use strict';

  // The snippet renders in both the header and the mobile main-menu, so this
  // script can be included twice. Guard so listeners are only ever bound once.
  if (window.__localizationFormInit) {
    return;
  }
  window.__localizationFormInit = true;

  function closestForm(el) {
    return el && typeof el.closest === 'function' ? el.closest('form') : null;
  }

  function setValueAndSubmit(form, inputName, value) {
    if (!form || !inputName || value == null) {
      return;
    }
    var input = form.querySelector('[data-localization-input="' + inputName + '"]') ||
      form.querySelector('input[name="' + inputName + '"]');
    if (!input) {
      return;
    }
    input.value = value;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function splitCodes(el, attr) {
    var raw = el ? el.getAttribute(attr) || '' : '';
    return raw.split(',').filter(Boolean);
  }

  // Group entries ("Europe", "International") carry data-localization-detect.
  // Their data-value is just a representative country; submitting it directly
  // would pre-fill checkout with that country (e.g. Åland Islands). Instead,
  // ask Shopify which country the visitor is actually in and submit that when
  // it belongs to the clicked group; fall back to the representative if
  // detection fails or the visitor's country is outside the group.
  function detectAndSubmit(link, inputName, fallbackValue, group) {
    var list = link.closest('[data-localization-list]');
    var eurCodes = splitCodes(list, 'data-localization-eur-codes');
    var curatedCodes = splitCodes(list, 'data-localization-curated-codes');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function submit(value) {
      setValueAndSubmit(closestForm(link), inputName, value);
    }

    if (typeof window.fetch !== 'function') {
      submit(fallbackValue);
      return;
    }

    fetch(root + 'browsing_context_suggestions.json?source[]=country&country[enabled]=true')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country &&
          data.detected_values.country.handle;
        var fits = false;
        if (detected) {
          if (group === 'eur') {
            fits = eurCodes.indexOf(detected) !== -1;
          } else {
            fits = eurCodes.indexOf(detected) === -1 && curatedCodes.indexOf(detected) === -1;
          }
        }
        submit(fits ? detected : fallbackValue);
      })
      .catch(function () {
        submit(fallbackValue);
      });
  }

  function onOptionClick(event) {
    var link = event.target.closest('[data-localization-option]');
    if (!link) {
      return;
    }
    event.preventDefault();
    var inputName = link.getAttribute('data-localization-option');
    var value = link.getAttribute('data-value');
    var detectGroup = link.getAttribute('data-localization-detect');
    if (detectGroup && inputName === 'country_code') {
      detectAndSubmit(link, inputName, value, detectGroup);
      return;
    }
    setValueAndSubmit(closestForm(link), inputName, value);
  }

  function onSelectChange(event) {
    var select = event.target;
    if (!select || select.tagName !== 'SELECT' || !select.name) {
      return;
    }
    if (select.name !== 'country_code' && select.name !== 'language_code') {
      return;
    }
    var form = closestForm(select);
    // Native select already carries the name, but mirror to the hidden input
    // (JS path) and submit so both paths behave identically.
    setValueAndSubmit(form, select.name, select.value);
  }

  function onToggleClick(event) {
    var toggle = event.target.closest('[data-localization-toggle]');
    if (!toggle) {
      return;
    }
    event.preventDefault();
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  }

  function init() {
    var forms = document.querySelectorAll('form[action*="/localization"], #CurrencySelectorForm');
    if (!forms.length) {
      return;
    }
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('click', function (event) {
        onToggleClick(event);
        onOptionClick(event);
      });
      form.addEventListener('change', onSelectChange);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
